var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"h6 text-bold text-uppercase p-y-2 m-0"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }